export function handleResponse(response: Response) {
  if (response.redirected) window.location.reload();
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      let error = data.ResponseStatus.Message;
      if (data.ResponseStatus.Errors && data.ResponseStatus.Errors.length > 0)
        error = data.ResponseStatus.Errors[0].Message;
      return Promise.reject({ status: response.status, message: error });
    }
    return data;
  });
}
